import { ThemeService } from "./core/services/theme.service";

export function initializeTheme(configService: ThemeService): () => void {
  return (): void => {
    configService.loadTheme();
  };
}
